import * as React from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, MenuItem, Paper, Popper } from '@mui/material';
import { LanguageSelection } from '@components';
import { logout, selectLoginState } from '@store';
import { showError } from '@utils';
import { useClickOutside } from '@hooks';
import { URLS } from '../constants';

import styles from './userMenu.styles';

export const UserMenu = ({ open }) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const ref = React.useRef();

  const [isOpen, setIsOpen] = React.useState(false);
  const { isLoggedIn, user } = useSelector(selectLoginState);
  const dispatch = useDispatch();

  const handleOpen = (event) => {
    setIsOpen(!isOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    // we need to keep id open when click on language selections
    // TODO: find a better way to handle
    if (e?.target?.classList?.contains?.('MuiSelect-root')) {
      return;
    }
    setIsOpen(false);
    setAnchorEl(null);
  };

  const handleLogOut = async () => {
    try {
      dispatch(logout());
      router.push(URLS.home);
    } catch (error) {
      showError(error);
    }
  };
  useClickOutside(ref, handleClose);

  if (!isLoggedIn || !user) {
    return null;
  }

  return (
    <>
      <Box sx={styles.wrapper} onClick={handleOpen} ref={ref}>
        {open && (
          <>
            <Box sx={styles.avatar}>
              <AccountCircleIcon
                data-testid="AccountCircleIcon"
                sx={styles.userIcon}
              />
              <Box sx={styles.statusDot} />
            </Box>
            <Box>
              <Box sx={styles.name}>{user?.name || 'User'}</Box>
              {user?.role && <Box sx={styles.role}>{user.role}</Box>}
            </Box>
          </>
        )}
      </Box>

      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement="right-end"
        disablePortal={false}
        style={{ zIndex: 9999 }}
        onClose={handleClose}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, -10],
            },
          },
        ]}
      >
        <Paper sx={styles.paper}>
          <MenuItem sx={styles.userMenuItem}>
            <Box sx={styles.langLabel}>LANGUAGE</Box>
            <LanguageSelection onChange={handleClose} />
          </MenuItem>
          <MenuItem sx={styles.logoutItem} onClick={handleLogOut}>
            <Box sx={styles.logout}>Log out</Box>
            <LogoutIcon data-testid="LogoutIcon" />
          </MenuItem>
        </Paper>
      </Popper>
    </>
  );
};

export default UserMenu;
